import urlConfig from 'Url';

export const QUERY_REFUNDCHANGE_FEE = 'QUERY_REFUNDCHANGE_FEE';
export const SAVE_QUERYINFO = 'SAVE_QUERYINFO';
export const INIT_STATE = 'INIT_STATE';
export const QUERY_REFUND_FEE = 'QUERY_REFUND_FEE';
export const QUERY_CHANGE_FEE = 'QUERY_CHANGE_FEE';
export const QUERY_CALCULATOR_TICKETS = 'QUERY_CALCULATOR_TICKETS';
export const GET_LOGINSESSIONTEMP = 'GET_LOGINSESSIONTEMP';

export function saveQueryInfo(data) {
  return { type: SAVE_QUERYINFO, data };
}

export function init() {
  return { type: INIT_STATE };
}

export function queryRefundChangeFee(data) {
  return {
    type: QUERY_REFUNDCHANGE_FEE,
    payload: {
      request: {
        url: urlConfig.queryRefundChangeFee,
        method: 'post',
        data,
      },
    },
  };
}

export function queryRefundFee(data) {
  return {
    type: QUERY_REFUND_FEE,
    payload: {
      request: {
        url: urlConfig.queryRefundFee,
        method: 'post',
        data,
      },
    },
  };
}

export function queryChangeFee(data) {
  return {
    type: QUERY_CHANGE_FEE,
    payload: {
      request: {
        url: urlConfig.queryChangeFee,
        method: 'post',
        data,
      },
    },
  };
}

export function queryCalculatorTickets(data) {
  return {
    type: QUERY_CALCULATOR_TICKETS,
    payload: {
      request: {
        url: urlConfig.queryCalculatorTickets,
        method: 'post',
        data,
      },
    },
  };
}

// 退改计算器免登
export function getLoginSessionTemp() {
  return {
    type: GET_LOGINSESSIONTEMP,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.getLoginSessionTemp,
        method: 'get',
        data: {},
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/feeQuery/modules/action.js